import {UPDATE_STEP, UPDATE_DATA, UPDATE_STORE, UPDATE_STAGE} from '../actions/application';
import { produce } from 'immer';

const initialState = {
  stage: 'organisation',
  step: 'welcome',
  stepNumber: 0,
  stepDirection: 'next',
  data: {},
  store: {}
};

const application = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DATA: {
      return produce(state, (draft) => {
        draft.data = {
          ...draft.data,
          [action.payload.section]: action.payload.data,
        };
      });
    }

    case UPDATE_STAGE: {
      return produce(state, (draft) => {
        draft.stage = action.payload.stage;
      });
    }

    case UPDATE_STORE: {
      return produce(state, (draft) => {
        draft.store = {
          ...draft.store,
          [action.payload.item]: action.payload.data,
        };
      });
    }

    case UPDATE_STEP: {
      return produce(state, (draft) => {
        draft.stepNumber = action.payload.number;
        draft.step = action.payload.name;
        draft.stepDirection = draft.stepNumber > state.stepNumber ? 'next' : 'previous';
      });
    }
    default: {
      return state;
    }
  }
};

export default application;
